<template>
  <el-dialog
    v-model="_isShow"
    width="90%"
    top="0"
    lock-scroll
    center
    show-close
    destroy-on-close
    :title="$t('calculation_review')"
  >
    <div>
      <div class="mb-6">{{ content }}</div>

      <el-button type="primary" class="w-full" @click="closeDialog">
        {{ $t('cancel') }}
        <KeyenceHTHardKeyButton
          v-if="isKeyenceEnterpriseBrowser"
          :hardkey="KeyenceHardKey.BACKSPACE"
          :function="closeDialog"
          :visible="_isShow"
          :newLayer="true"
        />
      </el-button>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import KeyenceHTHardKeyButton from '@/components/keyenceHT/hardkeys/KeyenceHTHardKeyButton.vue'
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'
import { KeyenceHardKey } from '@/utils/keyenceHT/keyenceHardKeyEventHandler'
import { isKeyenceEnterpriseBrowser } from '@/utils/keyenceHT/keyenceModules'

@Options({
  components: {
    KeyenceHTHardKeyButton,
  },
  emits: ['update:isShow'],
  name: 'ReviewCalculationDialog',
})
export default class ReviewCalculationDialog extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @Prop({ type: String }) readonly content?: string

  KeyenceHardKey = KeyenceHardKey

  get isKeyenceEnterpriseBrowser(): boolean {
    return isKeyenceEnterpriseBrowser()
  }

  closeDialog() {
    this._isShow = false
  }
}
</script>
<style lang="scss">
.edit-view.view {
  padding-left: 0;
  padding-right: 0;
}
</style>
